import { ChangeEvent, FC, PropsWithChildren, ReactNode } from 'react';
import CheckboxInput, { CheckboxInputProps } from '@/components/functional/CheckboxInput/CheckboxInput.tsx';
import {
  CheckboxGroupProvider,
  CheckboxGroupProviderProps,
  useCheckboxGroupContext,
} from '@/components/functional/CheckboxInput/CheckboxGroupContext.tsx';
import { useRadioContext } from '@/components/functional/RadioInput/RadioContext.tsx';

function Group<T extends any[]>({ children, ...props }: PropsWithChildren<CheckboxGroupProviderProps<T>>) {
  return <CheckboxGroupProvider {...props}>{children}</CheckboxGroupProvider>;
}

type InputProps = Omit<CheckboxInputProps, 'type'> & {
  render?: (
    props: Pick<CheckboxInputProps, 'value' | 'onChange'> &
      Pick<ReturnType<typeof useRadioContext>, 'error'> & {
        checked: boolean;
      }
  ) => ReactNode;
};

const Input: FC<InputProps> = ({ label, wrapperClassName, value, color, render, ...rest }) => {
  const { value: globalValue, setValue, error, color: globalColor } = useCheckboxGroupContext();

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  const checked = globalValue.includes(value);

  return render ? (
    render({
      value,
      onChange,
      checked,
      error,
    })
  ) : (
    <CheckboxInput
      wrapperClassName={wrapperClassName}
      error={error}
      label={label}
      value={value}
      checked={checked}
      onChange={onChange}
      color={color ?? globalColor}
      {...rest}
      type="checkbox"
    />
  );
};

export default {
  Group,
  Input,
};
